import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { useEnterprisePropertiesForEventing } from 'bundles/account-profile/common/eventing/useEnterprisePropertiesForEventing';
import Notification from 'bundles/notification-center/components/Notification';
import type {
  Notification as NotificationType,
  SetWeeklyGoalReminderNotification as SetWeeklyGoalReminderNotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: SetWeeklyGoalReminderNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

function SetWeeklyGoalReminderNotification({ notification, rank, onClick }: Props) {
  const enterpriseProperties = useEnterprisePropertiesForEventing();
  const courseSlug = notification.data.courseSlug;

  // The reason we are sending them to the course welcome page is so that the redirect will bring them to their relevant module.
  // Also, if the user clicks the notification while inside the core learning experience, we want to keep them there.
  const courseWelcomePageWithSetGoalParam = `/learn/${courseSlug}/home/welcome?setGoal=true`;

  return (
    <Notification
      onClick={onClick}
      href={courseWelcomePageWithSetGoalParam}
      notification={notification}
      rank={rank}
      trackingData={
        enterpriseProperties?.organizationSlug
          ? {
              enterprise: {
                organizationSlug: enterpriseProperties?.organizationSlug,
              },
            }
          : {}
      }
    >
      <FormattedHTMLMessage
        data-testid="set-weekly-goal-reminder-notification"
        message={_t('Take charge of your learning by <u>setting a learning plan now</u>.')}
      />
    </Notification>
  );
}

export default SetWeeklyGoalReminderNotification;
